export default __webpack_public_path__ + "static/media/thankyou.7de24698.png";